import EvOverviewPage from './pages/EvOverviewPage';
import EvReportPage from './pages/EvReportPage';
import LeadLayout from "./pages/EvLayout";

export const evChildrenRoutes = () => [
  {
    name: "EvOverviewPage",
    path: "/",
    component: EvOverviewPage
  },
  {
    name: "EvReportPage",
    path: "report",
    component: EvReportPage
  }
];

export const evRoutes = {
  path: "evparking",
  component: LeadLayout,
  children: [
    ...evChildrenRoutes()
  ]
};
